import app from "./../../app";
import _ from "./../../libs/lodash";
import moment from "./../../libs/moment";

const __ = window.__;

var innerObject = {
  init: {
    run: function () {
      webix.ajax().get("/api/history/count/" + user.id, function (data) {
        innerObject.settings.countOfChanges = parseInt(data, 10);
        innerObject.handlers.showWidget();
      });
    }
  },
  handlers: {
    increaseCount: function () {
      innerObject.settings.countOfChanges++;
      innerObject.handlers.showWidget();
    },
    showWidget: function () {
      var _gscq = window._gscq;

      if (innerObject.helpers.checkCount() && !_.isUndefined(_gscq)) {
        _gscq.push(['user', 'email', user.email]);
        _gscq.push(['targeting', user.locale, 'true']);
        _gscq.push(['targeting', 'free', 'true']);
        _gscq.push(['targeting', 'history', '100']);
      }
    }
  },
  helpers: {
    checkCount: function () {
      return innerObject.settings.countOfChanges > 100;
    },
    isFree: function () {
      return _.isUndefined(user.subscription.name) || user.subscription.name === "Free" || user.subscription.payment_plans_id === 0;
    },
    isOneWeekActive: function () {
      var weekAgoDate = moment().subtract(7, 'd'),
        regDate = moment(user.registrationTime);
      return regDate.isBefore(weekAgoDate);
    }
  },
  settings: {
    countOfChanges: 0
  }
};

var outputObject = {
  handlers: {}
};

if (innerObject.helpers.isFree() && innerObject.helpers.isOneWeekActive()) {
  app.on("gantt:init:before", innerObject.init.run);
}

export default outputObject;
